import { Component, OnInit, Compiler } from '@angular/core';
import { first, retry } from 'rxjs/operators';
import { Router } from '@angular/router';
import { FormBuilder, Validators, FormControl } from '@angular/forms';
import { NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import { AppConfig } from '../util';
import { CommonService } from '../service/commons-service';
import { Common } from '../util/common';
import { ExcelService } from '../service/excel.service';

@Component({
  selector: 'headerCustom',
  templateUrl: 'headerCustom.component.html',
  styleUrls: ['headerCustom.component.css'],
})
export class HeaderCustomComponent implements OnInit {
  loading: boolean = false;
  newNomination = '';
  users: any = {};
  isAppr: number;
  interesteNominee: any[] = [];
  // private submitted = false;
  isNomibtnShow: boolean = true;
  userId: any = 0;
  loginImageURL: any = '';
  baseURL: any = null;
  loginUserName: any = '';
  userRoll: number = 0;
  userType: any = '';
  showNominateButton:boolean = false
  constructor(
    private router: Router,
    // private formBuilder: FormBuilder,
    // private excelService: ExcelService,
    private commonService: CommonService,
    // private common: Common,
    private appConfig: AppConfig,
    config: NgbDatepickerConfig,
    private _compiler: Compiler
  ) {
    this._compiler.clearCache();
    this.users = JSON.parse(localStorage.getItem('user'));
    if (!this.users || !this.users.userData) {
      this.commonService.logout();
      return;
    }
    if (this.users && this.users.userData) {
      // this.users = this.users.userData;

      // this.loginUserName = this.users.userData.userFullName;
      // this.users.userFullName = this.users.userFullName.toLowerCase();
      // this.towerId = this.users.towerId;

      if (this.users.userFullName) {
        this.loginUserName = this.users.userData.userFullName;
      } else {
        this.loginUserName = this.users.userData.userName;
      }
      this.userRoll = this.users.userData.userRoll;

      switch (this.users.userData.userRoll) {
        case '1':
          this.userType = 'Super Admin';
          break;
        case '2':
          this.userType = 'Admin';
          break;
        case '3':
          this.userType = 'HR';
          break;
        case '4':
          this.userType = 'Supervisor';
          break;
        case '5':
          this.userType = 'Employee';
          break;
        default:
          this.userType = 'Employee';
          break;
      }
    }

    this.loginImageURL = this.appConfig.getDefaultImgURL();
  }

  openDashboard() {
    if (JSON.parse(localStorage.user).userData.userRoll == '1')
      this.router.navigate(['/adminDashboard']);
    else if (JSON.parse(localStorage.user).userData.userRoll == '5')
      this.router.navigate(['/selfRating']);
    else if (JSON.parse(localStorage.user).userData.userRoll == '3') {
      this.isNomibtnShow = false;
      this.router.navigate(['/dashboard']);
    } else if (JSON.parse(localStorage.user).userData.userRoll == '1') {
      this.isNomibtnShow = false;
      this.router.navigate(['/dashboard']);
    } else if (JSON.parse(localStorage.user).userData.userRoll == '2') {
      this.isNomibtnShow = false;
      this.router.navigate(['/dashboard']);
    } else if (JSON.parse(localStorage.user).userData.userRoll == '4') {
      this.isNomibtnShow = false;
      this.router.navigate(['/dashboard']);
    } else this.router.navigate(['/dashboard']);
  }

  ngOnInit() {
    const userData = JSON.parse(localStorage.user).userData
    if(userData.userRoll == 3 || userData.batchNo == 6)
      this.showNominateButton = true;

    if (JSON.parse(localStorage.user).userData.userRoll == 3) {
      this.isNomibtnShow = false;
    } else if (JSON.parse(localStorage.user).userData.userRoll == 2) {
      this.isNomibtnShow = false;
    } else if (JSON.parse(localStorage.user).userData.userRoll == 1) {
      this.isNomibtnShow = false;
    } else if (JSON.parse(localStorage.user).userData.userRoll == 4) {
      this.isNomibtnShow = false;
    }
    this.getAllUsersForTower();
  }

  // logout and forward to login page
  logout() {
    this.commonService.logout();
  }
  private checkNewNomination() {
    let formDetails = {
      newNomination: 'New Nomination Proceed',
      userId: this.userId,
    };
    this.commonService
      .userNewNominee(formDetails)
      .pipe(first())
      .subscribe(
        (data) => {},
        (error) => {
          localStorage.setItem('errorMsg', 'New Nomination failed');
          this.commonService.showerror();
          localStorage.removeItem('errorMsg');
        }
      );
  }

  private getAllUsersForTower() {
    var towerId = JSON.parse(localStorage.user).userData.towerId;
    var getUserId = JSON.parse(localStorage.user).userData.userId;
    var formDetails = {
      towerId: towerId,
      userId: getUserId,
    };
    this.commonService
      .getAllResoucesForTower(formDetails)
      .pipe(first())
      .subscribe(
        (data) => {
          this.interesteNominee = data;
          let appr;
          let newNomi = '';
          for (let i in this.interesteNominee) {
            if (this.interesteNominee[i].userId == getUserId) {
              appr = this.interesteNominee[i].isApproved;
              newNomi = this.interesteNominee[i].newNomination;
            }
            this.newNomination = newNomi;
            this.isAppr = appr;
            this.userId = getUserId;
          }
        },
        (error) => {
          localStorage.setItem('errorMsg', error.statusText);
          this.commonService.showerror();
          localStorage.removeItem('errorMsg');
        }
      );
  }
  onNomiClick() {
    if (this.isAppr == 0) {
      localStorage.setItem(
        'errorMsg',
        'You Have Already Nominated For Role! Please Check HR Comment In View Dtails, Any Concern Contact To Your HR'
      );
      this.loading = true;
      this.commonService.showerror();
      localStorage.setItem('isReload', 'true');
      localStorage.removeItem('errorMsg');
      this.loading = false;
    } else if (this.isAppr == 1) {
      localStorage.setItem(
        'errorMsg',
        'You have Already Nominated For next Role! Please contact to HR for further query'
      );
      this.loading = true;
      this.commonService.showerror();
      localStorage.setItem('isReload', 'true');
      localStorage.removeItem('errorMsg');
      this.loading = false;
    } else if (this.isAppr == 2) {
      if (!this.newNomination) {
        this.router.navigate(['/nominate']);
        this.checkNewNomination();
      } else {
        localStorage.setItem(
          'errorMsg',
          'You have Already Nominated for next role! Please contact to HR for further query'
        );
        localStorage.setItem('isReload', 'true');
        this.commonService.showerror();
        localStorage.removeItem('errorMsg');
      }
    } else {
      if (!this.newNomination) {
        this.router.navigate(['/nominate']);
        this.checkNewNomination();
      } else {
        localStorage.setItem(
          'errorMsg',
          'You have Already Applied! Please contact to HR for further query'
        );
        localStorage.setItem('isReload', 'true');
        this.commonService.showerror();
        localStorage.removeItem('errorMsg');
      }
    }
  }
}
